import {createDataStore} from '@shared_web/lib/data_store';

interface LoginInfo {
  email: string;
  nextCodeAt: string;
}

const loginInfoStore = createDataStore<LoginInfo | undefined>(undefined, {
  persist: {key: 'Mavismart-loginInfo'},
});

export const useLoginInfo = loginInfoStore.useData;
export const setLoginInfo = (loginInfo: LoginInfo) => loginInfoStore.setData(loginInfo);
export const clearLoginInfo = () => loginInfoStore.setData(undefined);
